import { capitalGlobalQuotesService } from '@/services/quotes/capital-global';
import type { CalculateQuoteResponse } from '@/services/quotes/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCalculateCapitalGlobalAnalysis(policyId: string) {
  const queryClient = useQueryClient();

  return useMutation<CalculateQuoteResponse, Error, void>({
    retry: false,
    mutationKey: ['capital-global', 'calculate-analysis', policyId],
    mutationFn: async () => {
      const response =
        await capitalGlobalQuotesService.calculateAnalysis(policyId);
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao calcular cotação em análise',
        );
      }
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['proposal-details', policyId],
      });
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
      queryClient.invalidateQueries({ queryKey: ['quotes-status-count'] });
    },
  });
}
